import React from "react";
const returnDate = (d) => {
  return new Date(d).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
const EVENTCOLOR = {
  opened: "green",
  clicked: "green",
  delivered: "blue",
  requests: "blue",
};
const BrevoEmailActivity = ({ plans }) => {
  return (
    <>
      {plans.length > 0 ? (
        <table className="plan_table mt-24">
          <thead className="plan_thead activityplan_thead">
            <tr className="plan_thead_tr plan_tr">
              <th className="plan_thead_tr plan_td">Email Subject</th>
              <th className="plan_thead_tr plan_td">Recipient</th>
              <th className="plan_thead_tr plan_td">Status</th>
              <th className="plan_thead_tr plan_td">Sent at</th>
            </tr>
          </thead>
          <tbody className="plan_tbody">
            {plans.map((plan) => (
              <tr key={plan._id} className="plan_tbody_tr plan_tr">
                <td className="plan_tbody_td plan_td">{plan.subject}</td>
                <td className="plan_tbody_td plan_td">{plan.email}</td>

                <td
                  style={{
                    color: EVENTCOLOR[plan.event]
                      ? EVENTCOLOR[plan.event]
                      : "red",
                  }}
                  className="plan_tbody_td plan_td"
                >
                  {plan.event === "requests"
                    ? "SENT"
                    : plan.event?.toUpperCase()}
                </td>
                <td className="plan_tbody_td plan_td">
                  {returnDate(plan?.date)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <h2>No Plans</h2>
      )}
    </>
  );
};

export default BrevoEmailActivity;
